// extracted by mini-css-extract-plugin
module.exports = {"games":"games___j7bLn","games__content":"games__content___2kqcT","gamesContent":"games__content___2kqcT","container":"container___1Z-eh"};